import * as R from 'ramda';

const rbacList = [
  {
    name: '订单创建',
    path: 'OrderCreate',
    id: 2,
    icon: 'menu-nav/create_orders',
    activeIcon: 'menu-nav/create_orders_active',
  },
  {
    name: '订单创建',
    path: 'AgentOrderCreate',
    id: 7,
    icon: 'menu-nav/create_orders',
    activeIcon: 'menu-nav/create_orders_active',
  },
  {
    name: '订单管理',
    path: 'Order',
    icon: 'menu-nav/orders',
    activeIcon: 'menu-nav/orders_active',
    children: [
      {
        name: '全部订单',
        path: 'OrderAll',
      },
      {
        name: '数据待提交',
        path: 'OrderUnsubmit',
        children: [
          {
            name: '待处理详情',
            path: 'OrderUnsubmitDetail',
            showType: 'API',
          }
        ]
      },
      {
        name: '数据已提交',
        path: 'OrderSubmited',
      },
      {
        name: '三维重建中',
        path: 'OrderProcessing',
      },
      {
        name: '重建已完成',
        path: 'OrderFinished',
      },
      {
        name: '全部订单',
        path: 'OrderAllInner',
      },
      {
        name: '数据待提交',
        path: 'OrderUnsubmitInner',
        children: [
          {
            name: '待处理详情',
            path: 'OrderUnsubmitDetail',
            showType: 'API',
          }
        ]
      },
      {
        name: '数据已提交',
        path: 'OrderSubmitedInner',
      },
      {
        name: '三维重建中',
        path: 'OrderProcessingInner',
      },
      {
        name: '重建已完成',
        path: 'OrderFinishedInner',
      },
      {
        name: '订单创建',
        path: 'AdminOrderCreate',
        id: 7,
        icon: 'menu-nav/create_orders',
        activeIcon: 'menu-nav/create_orders_active',
      }
    ],
  },
  {
    id: 3,
    name: '详情',
    path: 'OrderDetail',
    showType: 'API',
  },
  {
    id: 4,
    name: '账号管理',
    icon: 'menu-nav/account_manage',
    path: 'Account',
    activeIcon: 'menu-nav/account_manage_active',
    children: [{
      name: '账号添加',
      path: 'Add'
    }, {
      name: '科室管理',
      path: 'Department'
    }, {
      name: '代理商管理',
      path: 'Agent'
    }, {
      name: '医院管理',
      path: 'Hospital'
    }, {
      name: '医生管理',
      path: 'Doctor'
    }, {
      name: '科室编辑',
      path: 'DepartmentEdit',
      showType: 'API',
    }, {
      name: '代理商编辑',
      path: 'AgentEdit',
      showType: 'API',
    }, {
      name: '绩点管理',
      path: 'AdminScorePoint'
    }, {
      name: '绩点查询',
      path: 'WorkerScorePoint'
    }]
  },
  {
    name: '财务管理',
    path: 'FinanceManage',
    id: 9,
    icon: 'menu-nav/hospital_manage',
    activeIcon: 'menu-nav/hospital_manage_active',
    children: [{
      name: '财务查询',
      path: 'AgentMoneyDetail'
    }]
  },
  {
    name: '医生方管理',
    path: 'AgentHospitalManage',
    id: 5,
    icon: 'menu-nav/hospital_manage',
    activeIcon: 'menu-nav/hospital_manage_active',
    children: [{
      name: '账号添加',
      path: 'AgentAccountAdd'
    }, {
      name: '科室管理',
      path: 'AgentDepartmentManage'
    }, {
      name: '科室编辑',
      path: 'DepartmentEdit',
      showType: 'API',
    }]
  },
  {
    id: 6,
    name: '日志审计',
    icon: 'menu-nav/log_audit',
    path: 'LogAudit',
    activeIcon: 'menu-nav/log_audit_active',
    children: [
      {
        name: '下载异常',
        path: 'DownloadLog'
      },
      {
        name: 'IP地址异常',
        path: 'IPError'
      },
    ]
  },
  {
    id: 7,
    name: '模型配置',
    icon: 'menu-nav/log_audit',
    path: 'StlConfig',
    activeIcon: 'menu-nav/log_audit_active'
  },
  // {
  //   id: 8,
  //   name: '退款记录',
  //   icon: 'menu-nav/log_audit',
  //   path: 'refund',
  //   activeIcon: 'menu-nav/log_audit_active'
  // }
];

export const getRbacList = (whiteList) => {
  function computed(list) {
    const resultList = [];
    R.forEach((item) => {
      const {path, children} = item;
      const data = R.clone(item);
      if (R.is(Array, children) && R.length(children) > 0) {
        data.children = computed(children);
      }
      if (R.any(R.equals(path))(whiteList)) {
        resultList.push(data);
      }
    }, list);
    return resultList;
  }

  return computed(rbacList);
};



// WEBPACK FOOTER //
// ./src/config/rbac.js